// extracted by css-extract-rspack-plugin
export default {"iconStyle":"BVp4t"};